import moment from 'moment';

import type { Maybe } from 'shared/types';

/**
 * Whole days from now until a token/connection expires, given its expiry as a
 * Unix timestamp (seconds). Returns `undefined` when there is no timestamp or
 * the expiry is already in the past — callers use that to decide whether to
 * render an "Expires in" indicator at all.
 */
export default function expiresInDays(expiresTime: Maybe<number>): number | undefined {
  if (typeof expiresTime !== 'number') {
    return undefined;
  }
  const expiresMoment = moment.unix(expiresTime);
  const currentMoment = moment();
  if (expiresMoment.isBefore(currentMoment)) {
    return undefined;
  }
  return Math.round(expiresMoment.diff(currentMoment, 'days', true));
}

/**
 * The soonest of several expiry timestamps (Unix seconds), ignoring missing ones, for
 * connections gated by more than one credential.
 */
export function earliestExpiresTime(...expiresTimes: Maybe<number>[]): number | undefined {
  const times = expiresTimes.filter((time): time is number => typeof time === 'number');
  return times.length ? Math.min(...times) : undefined;
}
